var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgeAl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 24,
    rx: 4,
    fill: "#00A651"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21919 17L8.31519 5.8H10.7632L14.8432 17H12.5552L9.53119 8.264L6.49119 17H4.21919ZM6.02719 14.456L6.60319 12.776H12.2992L12.8592 14.456H6.02719ZM16.3149 17V5.8H18.4749V15.32H23.3869V17H16.3149Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeAl);
export default __webpack_public_path__ + "static/media/age-al.0f9c40a519e2746d7d8a898d5ca15a00.svg";
export { ForwardRef as ReactComponent };